import { leadInstance } from '@/libs/leadInstances';

export async function validateIdentityNumber({ identity_number }) {
  return leadInstance.post('/leads/identity-number/validate', {
    identity_number,
  });
}
